/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type StoryIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let StoryIcon: NessieFunctionComponent<StoryIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.104 3C1.494 3 1 3.494 1 4.104v13.175c0 .61.494 1.104 1.104 1.104H14.02l-1.405-1.648H2.662V4.648H20.39v4.698a4.543 4.543 0 011.662.125V4.104c0-.61-.494-1.104-1.104-1.104H2.104zm10.919 4.944l1.194 1.67c-1.65.638-2.822 2.23-2.822 4.09 0 .468.073.925.216 1.36H3.77c.863-3.589 6.106-2.332 6.106-2.332l3.147-4.788zm4.229 3.16c.033-.043.067-.086.102-.128l.044.128h-.146zm-10.144-.967c.925 0 1.675-.738 1.675-1.646 0-.908-.75-1.645-1.675-1.645-.926 0-1.676.737-1.676 1.645s.75 1.646 1.676 1.646zm11.316 1.8a3.225 3.225 0 00-2.536-1.246c-1.675 0-3.038 1.352-3.038 3.013 0 .654.207 1.276.6 1.799l4.536 5.32a.504.504 0 00.764.005l4.542-5.19c.456-.541.708-1.228.708-1.934 0-1.66-1.364-3.013-3.04-3.013-1.01 0-1.955.489-2.536 1.245z"
          />
          <mask maskUnits="userSpaceOnUse" x={1} y={3} width={23} height={18}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.104 3C1.494 3 1 3.494 1 4.104v13.175c0 .61.494 1.104 1.104 1.104H14.02l-1.405-1.648H2.662V4.648H20.39v4.698a4.543 4.543 0 011.662.125V4.104c0-.61-.494-1.104-1.104-1.104H2.104zm10.919 4.944l1.194 1.67c-1.65.638-2.822 2.23-2.822 4.09 0 .468.073.925.216 1.36H3.77c.863-3.589 6.106-2.332 6.106-2.332l3.147-4.788zm4.229 3.16c.033-.043.067-.086.102-.128l.044.128h-.146zm-10.144-.967c.925 0 1.675-.738 1.675-1.646 0-.908-.75-1.645-1.675-1.645-.926 0-1.676.737-1.676 1.645s.75 1.646 1.676 1.646zm11.316 1.8a3.225 3.225 0 00-2.536-1.246c-1.675 0-3.038 1.352-3.038 3.013 0 .654.207 1.276.6 1.799l4.536 5.32a.504.504 0 00.764.005l4.542-5.19c.456-.541.708-1.228.708-1.934 0-1.66-1.364-3.013-3.04-3.013-1.01 0-1.955.489-2.536 1.245z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
StoryIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  StoryIcon = nessiePropCheckerWrapper(StoryIcon);
}

export default StoryIcon;
